import { Controller } from "@hotwired/stimulus"
// import htmlToElems from "../src/shared/helpers/html_to_elems"
import authenticityToken from "../src/shared/helpers/authenticity_token"

// Connects to data-controller="contact-purchase"
export default class extends Controller {
  static targets = ['form']
  static outlets = ['modal-dialog']
  static values = {
    postNumber: String,
    price: Number,
    postTimestamp: String,
    section: String,
    customerPhone: String,
    supportPhone: String,
    telegramGroupMessageUrl: String
  }

  openModal() {
    if (!this.hasModalDialogOutlet) {
      const html = this.template({
        postNumber: this.postNumberValue,
        postTimestamp: this.postTimestampValue,
        price: this.priceValue,
        section: this.sectionValue,
        customerPhone: this.customerPhoneValue,
        supportPhone: this.supportPhoneValue,
        telegramGroupMessageUrl: this.telegramGroupMessageUrlValue
      })

      this.element.insertAdjacentHTML('afterend', html)
    }

    this.modalDialogOutlet.open()
  }

  template({ postNumber, postTimestamp, price, section, customerPhone, supportPhone, telegramGroupMessageUrl }) {
    let postTimestampCaption;

    if (section === 'bid') {
      postTimestampCaption = `Заявка размещена ${postTimestamp}`
    } else {
      postTimestampCaption = `Последнее редактирование объявления ${postTimestamp}`
    }

    return `<div id="contact_purchase_modal_${postNumber}"
                 data-controller="modal-dialog"
                 data-action="click->modal-dialog#backdropClose">
              <dialog class="modal-dialog" data-modal-dialog-target="dialog">
                <div class="modal-dialog-header" data-modal-dialog-target="header">Получение прямого контакта</div>

                <div class="modal-dialog-body max-w-lg" data-modal-dialog-target="body">
                  <form class="mb-0" method="post" action="/contact_purchases" data-contact-purchase-target="form">
                    <input type='hidden' name='contact_purchase[post_number]' value='${postNumber}'>
                    <input type='hidden' name='authenticity_token' value='${authenticityToken()}'>
                    <div class="form-group mb-20">
                      <label for="phone">Укажите ваш телефон</label>
                      <input class="mb-0"
                        type="text"
                        name="contact_purchase[customer_phone]"
                        placeholder="8 123 456-78-90"
                        value="${customerPhone}"
                        data-controller="phone-mask">
                    </div>

                    <p class="mb-10">${postTimestampCaption}</p>
                    <p class="mb-10">Сразу после оплаты номер телефона в объявлении будет доступен на сайте</p>

                    <div class="button-support_phone">
                      <button class="btn btn-primary action-button">Купить за ${price} р.</button>
                      ${telegramGroupMessageUrl ? `<a href="${telegramGroupMessageUrl}" class="btn btn-primary action-button" target="_blank">Посмотреть в Телеграмм-группе</a>` : ''}
                      <div>
                        Поддержка:
                        <a class="font-medium" href="tel:${supportPhone}">${supportPhone}</a>
                      </div>
                    </div>
                  </form>

                  <p class="text-muted mt-20 mb-0">
                    Отправляя запрос, вы соглашаетесь с 
                    <a href="https://spectehinfo.ru/legals/rules">пользовательским соглашением</a>
                    и 
                    <a href="https://spectehinfo.ru/legals/privacy_policy">политикой обработки данных</a>.
                  </p>

                </div>
              </dialog>
            </div>

            <style>
              .action-button {
                width: 100%;
                box-sizing: border-box;
              }

              .button-support_phone {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
              }

              @media (min-width: 480px) {
                .action-button {
                  width: auto;
                }

                .button-support_phone {
                  flex-direction: row;
                  justify-content: space-between;
                }
              }

            </style>`
  }
}
